import React, { Component } from 'react';
import { Icon } from "semantic-ui-react";
import moment from "moment/moment";
import { adpLink } from "../../../constants";

export default class GOx extends Component {

    getSortedArray = (arr) => {
        return arr.sort((a, b) => {
            return new Date(a.dateKey) - new Date(b.dateKey);
        })
    }

    render() {
        const { doctorName, startDate, contractType, numberOfDaysWorked, dentistWorkTimeType, mtdBillable,
            earnings, dailyRatePay, patientVisits, formatCurrency, unFormatCurrency, financialNotes,
            productionPayDetails, payRateOverBase, payChecks, prodAdjWo } = this.props;
        const annualizedPay = earnings * 12;
        const bCare = unFormatCurrency(mtdBillable)
        const procBasedPay = bCare * (payRateOverBase / 100);
        const percentageOfBillable = (procBasedPay / bCare) * 100;
        const workMonthBasePay = (this.props.dailyRatePay * numberOfDaysWorked);
        const avgDailyPay = (earnings / numberOfDaysWorked);
        return (
            <div>
                <div className="row">
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="ui card reports-card">
                            <div className="content">
                                <h5>{doctorName}</h5>
                                <ul className="data-list">
                                    <li>
                                        <p>Pay Month</p>
                                        <p>{moment(startDate).add(1, 'months').format('MMMM YYYY')}</p>
                                    </li>
                                    <li>
                                        <p>Work Month</p>
                                        <p>{moment(startDate).format('MMMM YYYY')}</p>
                                    </li>
                                    <li>
                                        <p>Total Earnings</p>
                                        <p>{formatCurrency(earnings)}</p>
                                    </li>
                                    <li>
                                        <p>Work Days</p>
                                        <p>{numberOfDaysWorked}</p>
                                    </li>
                                    <li>
                                        <p>Work Month Base Pay</p>
                                        <p>{formatCurrency(workMonthBasePay)}</p>
                                    </li>
                                    <li>
                                        <p>Annualized Earnings</p>
                                        <p>{formatCurrency(annualizedPay)}</p>
                                    </li>
                                    <li>
                                        <p>Avg Daily Earnings</p>
                                        <p>{formatCurrency(avgDailyPay)}</p>
                                    </li>
                                    <li>
                                        <p>Pt Visits</p>
                                        <p>{patientVisits}</p>
                                    </li>
                                    <li>
                                        <p>Pt Visits/ Day </p>
                                        <p>{(patientVisits / numberOfDaysWorked).toFixed(0)}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="ui card reports-card">
                            <div className="content">
                                <h5>Contract Details</h5>
                                <ul className="data-list">
                                    <li>
                                        <p>Contract Type</p>
                                        <p>{contractType}</p>
                                    </li>
                                    <li>
                                        <p>Day Rate</p>
                                        <p>{formatCurrency(dailyRatePay)}</p>
                                    </li>
                                    <li>
                                        <p>Percentage of Billable Care</p>
                                        <p>{percentageOfBillable.toFixed(0)}</p>
                                    </li>
                                    <li>
                                        <p>Gross to Billable Adjustment Percentage</p>
                                        <p>{100 - prodAdjWo}</p>
                                    </li>
                                    <li>
                                        <p>Work Status</p>
                                        <p>{dentistWorkTimeType}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="ui card reports-card">
                            <div className="content">
                                {payChecks && payChecks.depositDates && payChecks.depositDates.map((date, i) =>
                                    <React.Fragment>
                                        <div className="d-flex justify-content-between flex-wrap">
                                            <h5 className="mr10">{i + 1}{i === 0 ? 'st' : 'nd'} Friday Gross Earnings Pre-Tax</h5>
                                            <strong className="secondaryColor">{date}</strong>
                                        </div>
                                        <table className="table table-striped table-hover table-sm mt-0 mb-0">
                                            <thead>
                                                <tr>
                                                    <th>OFFICE</th>
                                                    <th className="text-right">EARNINGS</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {Object.entries(payChecks.practice).map(([practice, checks]) => <tr>
                                                    <td>{this.props.getPracticeName(practice)}</td>
                                                    <td className="text-right">{formatCurrency(checks.splits[i])}</td>
                                                </tr>)}

                                                <tr>
                                                    <td><strong>Total</strong></td>
                                                    <td className="text-right"><strong>{formatCurrency(Object.values(payChecks.practice).reduce((total, curr) => (total + curr.splits[i]), 0))}
                                                    </strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4">
                        <div className="ui card reports-card">
                            <div className="content">
                                <h5>Accessing Your Pay Stub</h5>
                                <ul className="data-list">
                                    <li>
                                        <p>Link to ADP</p>
                                        <p><a href={adpLink} target="_blank"><Icon name='external alternate' className="primaryColor" /></a></p>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
                <div className="table-responsive mb20">
                    <h5>Financial Notes</h5>
                    <table className="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th>
                                    <div>NOTES TYPE</div>
                                </th>
                                <th>
                                    <div>DATE</div>
                                </th>
                                <th>
                                    <div>TITLE</div>
                                </th>
                                <th>
                                    <div>PROVIDER</div>
                                </th>
                                <th>
                                    <div>DESCRIPTION</div>
                                </th>
                                <th>
                                    <div>AMOUNT</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {financialNotes}
                            {financialNotes.length < 1 && (<tr key={`financialNoteRowTotal`}>
                                <td colSpan={7}><strong>No records found</strong></td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
                <div className="table-responsive">
                    <h5>Pay Details</h5>
                    <table className="table table-striped table-hover">
                        <thead>
                            <tr>
                                <th>
                                    <div>SERVICE DATE</div>
                                </th>
                                <th>
                                    <div>PRACTICE</div>
                                </th>
                                <th>
                                    <div>GROSS CARE</div>
                                </th>
                                <th>
                                    <div>ADJUSTMENT</div>
                                </th>
                                <th>
                                    <div>WRITE OFF</div>
                                </th>
                                <th>
                                    <div>EXCLUDED XRAYS </div>
                                </th>
                                <th>
                                    <div>BILL PROD MINUS XRAYS</div>
                                </th>
                                <th>
                                    <div>FINANCIAL NOTES</div>
                                </th>
                                <th>
                                    <div>EARNINGS</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.getSortedArray(productionPayDetails)}
                            {productionPayDetails.length < 1 && (<tr key={`productionPayDetailsRowTotal`}>
                                <td colSpan={5}><strong>No records found</strong></td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}